import { render, staticRenderFns } from "./wf-parallel-radio-buttons-display.vue?vue&type=template&id=e22c3114&scoped=true&"
import script from "./wf-parallel-radio-buttons-display.vue?vue&type=script&lang=ts&"
export * from "./wf-parallel-radio-buttons-display.vue?vue&type=script&lang=ts&"
import style0 from "./wf-parallel-radio-buttons-display.vue?vue&type=style&index=0&id=e22c3114&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e22c3114",
  null
  
)

export default component.exports